import Centrifuge from 'centrifuge';
import SockJS from 'sockjs-client';

let centrifuge;
const subscriptions = {};
export default {
  configure(config) {
    const cf = {
      ...config,
      sockJS: SockJS,
    };
    centrifuge = new Centrifuge(cf);
  },
  addSubscription(channel, callbacks) {
    const s = centrifuge.subscribe(channel, callbacks);
    subscriptions[channel] = s;
    return s;
  },
  isSubscribed(channel) {
    const s = subscriptions[channel];
    return !!s;
  },
  unsubscribe(channel) {
    subscriptions[channel].unsubscribe();
    delete subscriptions[channel];
  },
  start() {
    centrifuge.connect();
  },
};



// WEBPACK FOOTER //
// ./src/centrifugo/chat.js